<template>
  <span v-if="showInstallments" class="wrapper-installments-promotion">
    <span v-for="month in installments" :key="month" class="discount-value">
      <span
        >{{
          $t(`general.promo_type.msi`, {
            month,
          })
        }}
      </span>
    </span>
  </span>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadPriceMSI',
  props: {
    product: { type: Object, default: () => ({ is_lad: false }) },
  },
  computed: {
    ...mapState('settings', {
      currency: (state) => state.currency,
      paymentPlans: (state) => state.payment_plans,
    }),
    isLad() {
      return this.product.is_lad
    },
    /** meses sin intereses */
    showInstallments() {
      const k = this.isLad ? 'lad' : 'others'

      return (this.paymentPlans[k] || []).some((t) => t.percent === 0)
    },
    /** lista meses sin intereses */
    installments() {
      const k = this.isLad ? 'lad' : 'others'

      return (this.paymentPlans[k] || [])
        .filter((t) => t.percent === 0)
        .map((t) => t.month)
    },
  },
}
</script>

<style lang="scss">
.wrapper-installments-promotion {
  .discount-value {
    & + .discount-value {
      margin-left: 4px;
    }
  }
}
</style>
